import user from './user'
import role from './role'
import menu from './menu'
import auth from './auth'
import account from './account'
import transfer from './transfer'
import out from './out'
import permission from './permission'
import outverify from './outverify'
import sms from './sms'
import outcategory from './outcategory'
import wechat from './wechat'
import schedule from './schedule'
import attendance from './attendance'
import daka from './daka'
import contribute from './contribute'
import order from './order'
import product from './product'
import payment from './payment'
import paymentdetail from './paymentdetail'
import paymentverify from './paymentverify'
import invoice from './invoice'
import release from './release'

export default {
  user,
  role,
  menu,
  auth,
  account,
  transfer,
  out,
  permission,
  outverify,
  sms,
  outcategory,
  wechat,
  schedule,
  attendance,
  daka,
  contribute,
  order,
  product,
  payment,
  paymentdetail,
  paymentverify,
  invoice,
  release
}



// WEBPACK FOOTER //
// ./src/api/index.js